import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";

const OurPlans = () => {
  const theme = useTheme();

  return (
    <Box 
      className="our-plans-container" 
      sx={{ 
        textAlign: 'center', 
        padding: '50px 20px', 
        maxWidth: '1200px', 
        margin: '0 auto'
      }}
    >
      <Typography variant="h1" sx={{ marginBottom: '20px' }}>
        Our Plans
      </Typography>
      
      <Typography variant="body1" sx={{ fontSize: '18px', marginBottom: '10px' }}>
        We offer different membership options to help you connect with other developers.
      </Typography>
      
      <Box sx={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.05)', 
        padding: '30px', 
        borderRadius: '10px',
        marginTop: '30px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
      }}>
        <Typography variant="h2" sx={{ marginBottom: '20px' }}>
          Visit Our Plans Page
        </Typography>
        
        <Typography variant="body1" sx={{ marginBottom: '20px' }}>
          Our complete membership plans and pricing details are available on our dedicated plans page.
        </Typography>
        
        <Button
          component="a"
          href="https://main.d2tb1l5gisdl3q.amplifyapp.com/"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="primary"
          sx={{
            padding: '12px 24px',
            fontWeight: 'bold',
            fontSize: '16px',
          }}
        >
          View Membership Plans
        </Button>
      </Box>
      
      <Box sx={{ marginTop: '50px' }}>
        <Typography variant="h2" sx={{ marginBottom: '20px' }}>
          Why Join Us?
        </Typography>
        
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          gap: '20px',
          marginTop: '20px'
        }}>
          <Box sx={{ 
            flex: '1 1 300px',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}>
            <Typography variant="h5" sx={{ marginBottom: '10px', color: theme.palette.primary.main }}>
              Access to Projects
            </Typography>
            <Typography variant="body1">
              Connect with interesting projects that match your skills and interests.
            </Typography>
          </Box>
          
          <Box sx={{ 
            flex: '1 1 300px',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}>
            <Typography variant="h5" sx={{ marginBottom: '10px', color: theme.palette.primary.main }}>
              Community Support
            </Typography>
            <Typography variant="body1">
              Join groups of like-minded developers to share ideas and knowledge.
            </Typography>
          </Box>
          
          <Box sx={{ 
            flex: '1 1 300px',
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}>
            <Typography variant="h5" sx={{ marginBottom: '10px', color: theme.palette.primary.main }}>
              Skill Development
            </Typography>
            <Typography variant="body1">
              Enhance your skills by working on real-world collaborative projects.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OurPlans; 